export default {
  forgot_password_submit: {
    title: '패스워드 초기화',
    submit_complete: '송신 완료',
    password_reset: '패스워드 초기화되었습니다.',
  },
}
